import React, { useEffect, useState } from 'react'
import LoadingContainer from '../../controls/LoadingContainer'
import { useToast } from '../../controls/Toast/ToastService'
import Empty from '../../controls/Empty'
import { MdErrorOutline } from 'react-icons/md'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import Paging from '../../controls/Paging'
import { PAGE_SIZE } from '../../../configurations/initUrls';
import { EBoolBg, GetEBoolName } from '../../../configurations/enums/EBool';
import StatusContainer from '../../controls/StatusContainer';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Input from '../../controls/Input';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { IoMdOpen } from 'react-icons/io';
import { ESourceBg, GetESourceName } from '../../../configurations/enums/ESource';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import moment from 'moment';
import { EOPDRegisteredStatusBg, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus'
import { GetEGenderName } from '../../../configurations/enums/EGender'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import Select from '../../controls/Select'
import { FaClinicMedical } from 'react-icons/fa'
import { GetAllByUser } from "../../../configurations/crud/opdCentersCrud"

export default function GetTodaysRegistered() {
  const { userid } = useParams()
  const initValues = {
    UserId: userid,
    CenterId: "",
    PageNo: 1,
    PageSize: PAGE_SIZE,
    SearchTerm: "",
  }
  const { start, end } = useGlobalLoader()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [userData, setUserData] = useState([]);
  const [search, setSearch] = useState(initValues);
  const [LastPage, setLastPage] = useState(1);
  const [pagingData, setPagingData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDebounce, setSearchDebounce] = useDebounce("", 700);

  useEffect(() => {
    setSearchDebounce(searchTerm)
  }, [searchTerm])

  useEffect(() => {
    onSearch()
  }, [searchDebounce])


  const OnPageChange = (e) => {
    setSearch({ ...search, PageNo: e })
    onSearchNew({
      UserId: search.UserId,
      CenterId: search.CenterId,
      PageNo: e,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm
    })
  }
  const onSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }
  const onSearch = () => {
    if (searchTerm) {
      setSearch({ ...search, CenterId: searchTerm })
      onSearchNew({
        UserId: search.UserId,
        CenterId: searchTerm,
        PageNo: 1,
        PageSize: search.PageSize,
        SearchTerm: ""
      })
    }
  }
  const onSearchNew = (search) => {
    GetTodaysRegister(search)
  }

  const doRefresh = () => {
    setSearch({ ...search, PageNo: 1 })
    onSearchNew({
      PageNo: 1,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm
    })
  }

  const GetTodaysRegister = (params) => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetTodaysRegistered(params).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setUserData(mdata.data)
        setPagingData(mdata.paging)
        setLastPage(mdata.paging.pageCount)
      } else {
        setPagingData()
        setLastPage(1)
        setUserData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setPagingData()
      setLastPage(1)
      setUserData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const [opdCenters, setOpdCenter] = useState([]);
  useEffect(() => {
    getAllOpdCenters()
  }, [])
  function getAllOpdCenters() {
    setLoding(true);
    start()
    GetAllByUser()
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setOpdCenter(mdata.data);
        } else {
          setOpdCenter([]);
          toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setOpdCenter([]);
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }
  return (
    <div className='flex flex-col '>
      <div className='py-3'>
        <Select
          Icon={<FaClinicMedical className="text-lg text-red-600" />}
          value={searchTerm}
          onChange={onSearchChange}
        >
          <option value="">Select Center...</option>
          {opdCenters.map(item => (
            <option key={item.id} value={item.id}>{item.centerName}</option>
          ))}
        </Select>
      </div>
      <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData} >
        <div class="overflow-x-auto">
          {
            !loding ?
              userData.length > 0 ?
                <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                  <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                    <tr>
                      <th scope="col" class="px-2 py-3">
                        <div class="flex items-center">
                          <input id="checkbox-all" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 " />
                          <label for="checkbox-all" class="sr-only">checkbox</label>
                        </div>
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Center
                      </th>
                      <th scope="col" class="px-2 py-3">
                        #
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Patient Name
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Gender
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Address
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Phone
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Weight
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Note
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Date
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Reserved
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Status
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Source
                      </th>
                      <th scope="col" class="px-2 py-3">
                        Type
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData.map((item, index) =>
                      <tr class="bg-white border-b hover:bg-gray-100 ">
                        <td class="w-4 px-2 py-2">
                          <div class="flex items-center">
                            <input id="checkbox-table-search-1" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 " />
                            <label for="checkbox-table-search-1" class="sr-only">checkbox</label>
                          </div>
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.opdCenter.centerName}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.id}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.patientName}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {GetEGenderName(item.gender)}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.patientAddress}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.mobile}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.weight}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {item.note ? item.note : "N/A"}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          {moment(item.onDate).format("DD/MMM/YYYY")}
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          <StatusContainer bg={EBoolBg(item.isReserved)} text={GetEBoolName(item.isReserved)} />
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          <StatusContainer bg={EOPDRegisteredStatusBg(item.status)} text={GetEOPDRegisterStatusName(item.status)} />
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
                        </td>
                        <td class="px-2 py-2 text-nowrap">
                          <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
                        </td>
                      </tr>
                    )}

                  </tbody>
                </table>
                : <Empty>
                  No Items Found.
                </Empty>
              : <LoadingContainer />
          }
        </div>
      </Paging>
    </div>
  )
}